import React, { useState } from "react";

function Loader({ text }) {

  return (
    <>
      <div className="">
        <div
          className="position-fixed w-100 mainLoader"
          style={{
            zIndex: 1100000000000,
            // marginTop: -200,
            height: '100%',
            marginLeft: 0,
            background: "var(--loader-bg)",
            backdropFilter: "blur(20px)",
            top: '0px',
            left: '0px'
          }}
        >
          <div className="h-100 d-flex align-items-center justify-content-center">
            <div className="d-flex flex-wrap align-items-center justify-content-center" style={{flexDirection : 'column'}}>
              <img width={120} className="mt-n4 round-moving-animation" src="\loader.svg" alt="loader" />
              <p
                className="text-center loader-text"
              >
                {text}
                {/* Please sign transaction from your wallet */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Loader;